<template>
	<dialog-slot
			:title="getCurrentDate"
			@updateClose="onClose"
			@updateSave="onSave"
			apply-text="Save"
			width="1200px"
			:is-show-button-groups="false"
	>
		<details-payments-table
				v-if="calendarFilterList"
				:filter="calendarFilterList"
				:list-items="calendarList"
				@updateEditDetails="onEditDetails"
				@updateDetailsPaymentsFilters="onDetailsPaymentsFilters"
		></details-payments-table>
		<details-drawer
				v-if="drawer && editItem"
				:editItem="editItem"
				:groupIds="groupIds"
				:isPreload="isPreload"
				:isEdit="isEdit"
				:isDelete="isDelete"
				@updateDrawerClose="onDrawerClose"
				@updateEditSave="onEditSave"
				@updateDeletePayment="onDeletePaymentPopup"
		></details-drawer>
		<delete-payment
				v-if="isDeletePayment"
				@updateClose="onDeletePaymentClose"
				@updateDeleteItem="onDeleteItem"
		></delete-payment>
		<preload v-if="preloader"></preload>
</dialog-slot>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import DetailsPaymentsTable from "@/components/Accounting/Calendar/DetailsPayments/DetailsPaymentsTable/DetailsPaymentsTable";
import DetailsDrawer from "@/components/Accounting/Calendar/DetailsDrawer/DetailsDrawer";
import DeletePayment from "@/components/Accounting/Calendar/DetailsPayments/DeletePayment/DeletePayment";
// moment
import moment from "moment";
// shared
import Preload from "@/shared/Preload/Preload";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "DetailsPayments",
	props: {
		isEdit: Boolean,
		isDelete: Boolean,
		date: String
	},
	components: {
		DialogSlot,
		DetailsPaymentsTable,
		DetailsDrawer,
		DeletePayment,
		Preload
	},
	computed: {
		...mapGetters([ 'calendarFilterList', 'calendarList' ]),
		getCurrentDate() {
			const [ dayOfWeek, monthAndDay ] = moment(this.date).format('LLLL').split(',');
			return `${ dayOfWeek }, ${ monthAndDay }`;
		}
	},
	data: () => ({
		isPreload: false,
		isPopup: true,
		groupIds: null,
		preloader: false,
		drawer: false,
		editItem: null,
		isDeletePayment: false
	}),
	methods: {
		...mapActions([ 'getCalendarList', 'getEditCalendar', 'onEditCalendar', 'onEditCalendar', 'setAlert', 'onDeletePayment', 'actionPreloader' ]),
		onClose() {
			this.$emit('updateClose');
		},
		onNewOrder(id) {
			this.$emit('updateNewOrder', id);
		},
		onCommentsPopup(values) {
			this.$emit('updateCommentsPopup', values);
		},
		async onEditDetails(groupIds) {
			this.groupIds = groupIds;
			this.actionPreloader(true);
			this.editItem = await this.getEditCalendar({ id: groupIds.scheduled_id, date: this.date });
			this.drawer = true;
			this.actionPreloader(false);
		},
		onDrawerClose() {
			this.editItem = null;
			this.groupIds = null;
			this.drawer = false;
			this.isDeletePayment = false;
		},
		async onEditSave(values) {
			this.isPreload = true;
			const { status } = await this.onEditCalendar(values);
			if (status) {
				await this.initDetails();
				this.onDrawerClose();
				this.$emit('updateEditCalendar');
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreload = false;
		},
		async onDeleteItem(payment_type) {
			this.isPreload = true;
			const { status } = await this.onDeletePayment({ id: this.groupIds?.id, payment_type });
			if (status) {
				await this.initDetails();
				this.onDrawerClose();
				this.$emit('updateEditCalendar');
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreload = false;
		},
		onDeletePaymentPopup() {
			this.isDeletePayment = true;
		},
		onDeletePaymentClose() {
			this.isDeletePayment = false;
		},
		async onDetailsPaymentsFilters(filters) {
			this.preloader = true;
			await this.getCalendarList({ date: this.date, filters });
			this.preloader = false;
		},
		async initDetails() {
			this.preloader = true;
			await this.getCalendarList({ date: this.date });
			this.preloader = false;
		}
	},
	async mounted() {
		await this.initDetails();
	}
};
</script>

<style scoped lang="scss">
@import "DetailsPayments";
</style>
